<template>
  <div>
    <Layout :pagetitle="$t('Sub Brand')">
      <Table
        :title="$t('Sub Brand')"
        :items="subBrands"
        :columns="columns"
        :totalItems="totalItems"
        :showButtons="true"
        :searchable="true"
        :editable="true"
        :removable="true"
        :showPagination="true"
        @onSearch="onSearch"
        @onEdit="editSubBrand"
        @onCreate="createSubBrand"
        @onRemove="onRemove"
        @onChangePage="changePage"
      />
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';

export default {
  components: { Layout, Table },
  data() {
    return {
      search: '',
      page: 1,
      totalItems: 0,
      columns: [
        {
          key: 'name',
          label: this.$t('Name')
        },
        {
          key: 'brand_name',
          label: this.$t('Brand')
        },
        {
          key: 'is_active',
          label: this.$t('Active'),
          formatter: (v) => (v == 'true' ? 'Yes' : 'No')
        }
      ],
      subBrands: []
    };
  },
  mounted() {
    this.getSubBrand();
  },
  methods: {
    changePage(page) {
      this.page = page;
      this.getSubBrand();
    },
    onRemove(subBrand) {
      this.$api.destroy(`api/subBrand/${subBrand.id}`).then(() => {
        this.$customAlert({
          type: 'success',
          msg: this.$t('SubBrand was excluded with success')
        });
        this.getSubBrand();
      });
    },
    getSubBrand() {
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get('api/subBrand', { search: this.search, page: this.page })
        .then((res) => {
          this.page = 1;
          this.$store.commit('SET_LOADING', false);
          this.subBrands = (res.data?.results || []).map((sb) => {
            return {
              ...sb,
              brand_name: sb.brand.name
            };
          });
          this.totalItems = res.data.total;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    createSubBrand() {
      this.$router.push({
        name: 'subBrandCreate'
      });
    },
    editSubBrand(subBrand) {
      this.$router.push({
        name: 'subBrandUpdate',
        params: {
          id: subBrand.id
        }
      });
    },
    onSearch(search = '') {
      this.search = search;
      this.getSubBrand();
    }
  }
};
</script>

<style></style>
